export const WAVE_SOCKET_TOPICS = {
	LOGON_REQUEST: 'LOGON',
	MULTIPLE_TOUCHLINE_REQUEST: 'MULTIPLE_TOUCHLINE',
	BEST_FIVE_SUBSCRIPTION: 'BEST_FIVE_SUBSCRIPTION',
	TRADE_EXECUTION_RANGE: 'TRADE_EXECUTION',
	ON_OPEN_CONNECTION: 'ON_OPEN_CONNECTION',
	MOST_ACTIVE_OPTIONS: 'MOST_ACTIVE_OPTIONS',
	ORDER_PLACED: 'ORDER_PLACED',
	ON_CLOSE_CONNECTION: 'ON_CLOSE_CONNECTION',
	ON_CLOSE_TRADE_CONNECTION: 'ON_CLOSE_TRADE_CONNECTION',
	TRADE_LOGON: 'TRADE_LOGON',
	USR_ALERT: 'USR_ALERT',
};

export const SOCKET_VALUES = {
	LOGON_SUCCESS: '10000',
};
